document.addEventListener('DOMContentLoaded', function() {
    // Obtén todos los elementos <details> en la página
    const detailsElements = document.querySelectorAll('details');
  
    // Agrega un evento de clic a cada elemento <details>
    detailsElements.forEach((details) => {
      details.addEventListener('click', () => {
        // Cierra todos los elementos <details> excepto el que se hizo clic
        const index = details.getAttribute('data-index');
        detailsElements.forEach((element) => {
          if (element.getAttribute('data-index') !== index) {
            element.removeAttribute('open');
          }
        });
      });
    });
  });
  